import axios from 'axios';

let endpoint = '/api/2022-10/graphql.json';
let nonCachedEndpoint = '/api/2022-10/graphql.json';
let accessToken = 'fa98051ab0dc8c6fe7c764ce8de9a983';

// Cache API request if Edgemesh instance
// /em-cgi/cache/{TTL}/{pathname}
if (window.edgemesh && window.Shopify?.theme?.role === 'main') {
  endpoint = '/em-cgi/cache/300/api/2022-10/graphql.json';
}

if (window.Shopify?.shop === 'cariuma-testnew.myshopify.com') {
  accessToken = 'a532ca5baee341e516e2b827927c6fef';
}

if (window.Shopify?.shop === 'int-cariuma.myshopify.com') {
  accessToken = '7f04160fc2d4644ec408c4295e0ba329';
}

if (window.Shopify?.shop === 'cn-cariuma.myshopify.com') {
  accessToken = 'ee06a6ef1a001b0d889df07f8af69c73';
}

export const ajaxRequest = query => {
	return axios.get(query)
		.then(response => response)
		.catch(error => new Error(error));
}

export const graphQLRequest = (query, variables, ajaxQuery = null, nonCachedAPI = false) =>
	fetch(nonCachedAPI ? nonCachedEndpoint : endpoint, {
		method: 'POST',
		headers: {
			'x-shopify-storefront-access-token': accessToken,
			'content-type': 'application/json',
		},
		body: JSON.stringify({ query, variables }),
	}).then((res) => {
		if (res.ok) return res.json();
		if (res.status === 400 && ajaxQuery) return ajaxRequest(ajaxQuery)
		else throw new Error(`Response code: ${res.status}`);
	}).catch(error => {
		if (ajaxQuery) return ajaxRequest(ajaxQuery)
		else throw new Error(error)
	});
